import { color } from '@evrekadev/evreka-ui-components'
import React from 'react'
import styled from 'styled-components'

export const ChatLoading: React.FC = () => {
  return (
    <Loading>
      <LoadingDot />
      <LoadingDot />
      <LoadingDot />
    </Loading>
  )
}

const Loading = styled.div`
  display: flex;
  gap: 0.25rem;

  & > :nth-child(2) {
    animation-delay: 0.1s;
  }

  & > :nth-child(3) {
    animation-delay: 0.2s;
  }
`

const LoadingDot = styled.div`
  height: 0.5rem;
  width: 0.5rem;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${color('grey400')};
  animation: bounce 0.5s infinite alternate;

  @keyframes bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-0.25rem);
    }
  }
`
